// RowActionsMenu.jsx
import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PropTypes from "prop-types";

const RowSocietyActionsMenu = ({
  row,
  onEdit,
  onSocietyDelete,
  onCreateSocietyUser,
  onCreateCollege,
  onViewSocietyUsers,
  onViewColleges,
  hasPermissionDirect,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const isInactive = row.is_society_active == 0;
  return (
    <>
      <IconButton onClick={handleOpen}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem
          onClick={() => {
            onEdit(row);
            handleClose();
          }}
        >
          Edit Society
        </MenuItem>

        <MenuItem
          disabled={isInactive}
          onClick={() => {
            onSocietyDelete(row.society_id);
            handleClose();
          }}
        >
          Delete Society
        </MenuItem>

        <MenuItem
          disabled={isInactive}
          onClick={() => {
            onCreateSocietyUser(row.society_id, row.society_name, row.client_id);
            handleClose();
          }}
        >
          Create User
        </MenuItem>

        <MenuItem
          disabled={isInactive}
          onClick={() => {
            onViewSocietyUsers(row.society_id, row.society_name, row.client_id);
            handleClose();
          }}
        >
          View Users
        </MenuItem>

        <MenuItem
          disabled={isInactive}
          onClick={() => {
            onCreateCollege(row.society_id, row.society_name, row.db_instance_id);
            handleClose();
          }}
        >
          Create College
        </MenuItem>

        <MenuItem
          disabled={isInactive}
          onClick={() => {
            onViewColleges(row.society_id, row.society_name, row.client_id);
            handleClose();
          }}
        >
          View Colleges
        </MenuItem>
      </Menu>
    </>
  );
};
RowSocietyActionsMenu.propTypes = {
  row: PropTypes.shape({
    society_id: PropTypes.number.isRequired,
    society_name: PropTypes.string.isRequired,
    client_id: PropTypes.number.isRequired,
    db_instance_id: PropTypes.number,
    is_society_active: PropTypes.number.isRequired,
  }).isRequired,
  onEdit: PropTypes.func.isRequired,
  onSocietyDelete: PropTypes.func.isRequired,
  onCreateSocietyUser: PropTypes.func.isRequired,
  onCreateCollege: PropTypes.func.isRequired,
  onViewSocietyUsers: PropTypes.func.isRequired,
  onViewColleges: PropTypes.func.isRequired,
  hasPermissionDirect: PropTypes.func.isRequired,
};
export default RowSocietyActionsMenu;
